import React from "react";
import {
  DialogInner,
  DialogInnerProps
} from "@emisgroup/ui-dialog";

interface CustomDialogProps {
  /**
   * Optional class name for custom styles
   */
  className?: string;
}

type DialogProps = DialogInnerProps & CustomDialogProps;

/**
 * Responsible for rendering the dialog
 * @returns the dialog
 */
export const UIDialogInner: React.FC<DialogProps> = (props: DialogProps) => {
  const { className, ...remainingProps } = props;

  return (
    <DialogInner
      className={className}
      {...remainingProps}
    />
  );
};
